<template>
<div id="calendarComponent" class="wrapper">
</br>
    <div class="alert alert-danger" v-if="errorMsg">
        <p>{{ errorMsg }}</p>
        </div>
        <div class="alert alert-info" v-if="alertMsg">
        <p> {{alertMsg}}</p>
    </div>
  <div id="calendar">
                
  </div>
  




</div>

</template>

<script>

import Vue from 'vue'

export default {
        name: 'CalendarView',
        props: ['sitterId'],
        data() {
            return{
                tempEvent:{
                    id: '',
                    title: '',
                    start: '',
                    end: ''
                },
                error: '',
                alert: '',
                datepicked: '',
                newEvent:{
                    id: '',
                    title: '',
                    start: '',
                    end: ''
                },
                events:[]
            }
            
        },
        methods:{
            initCalendar(){
                
                self = this
                var now = new Date()
                $('#calendar').fullCalendar({
                selectable: false,
                dayRender: function(date, cell) {
                        if (date < now){
                            $(cell).addClass('disabled');
                        }
                },
                height:'auto',
                allDay: true,
                displayEventTime: false,
                ignoreTimezone: false,
                header: {
                      left:   'title',
                      center: '',
                      right:  'prev,next'
                    
                },
                eventRender: function(event, element){
                    if (event.end <  new Date()){
                    element.hide();
                    }
                    if (event.type==0)
                        element.find('.fc-content').prepend(" <i style='display: initial; margin-left:2px;' class='fa fa-plane'/> " ); 

                    else if (event.type==1)
                        element.find('.fc-content').prepend ("<i style='display: initial; margin-left:2px; margin-bottom:0px; padding-bottom:0px' class='fa fa-paw'/> " ); 
                
                    
                },
            });
            
      
            },
            initEvents(){
                self = this
                $.ajax({
                        type: 'GET',
                        url: 'https://www.dupaws.com/services/public/GetPublicEvents/' + self.sitterId,
                        crossDomain: true,
                        contentType: "application/json; charset=utf-8",
                      
                        success: function (data) {
                            var tempEvents = []
                            if (data){

                            
                            var len = data.length;
                            for (var i = 0; i<len; i++){
                                tempEvents.push({
                                    start: moment(data[i].Start).format('YYYY-MM-DD'),
                                    end: moment(data[i].End).add(12,'hours').format('YYYY-MM-DD HH'),
                                    title: data[i].Title,
                                    type: data[i].EventType,
                                    color: data[i].Color,
                                    blocking: data[i].Blocking
                                })
                            }
                            
                            self.events = tempEvents
                            $('#calendar').fullCalendar( 'addEventSource', self.events);
                            } else
                            {
                                console.log("no events found")
                            }
                            
                            
                        },
                        error:function(){
                        try {
                            self.error = "Couldn't connect to server, please try again later"
                        } catch(e)
                        {
                            self.error = "Oops we are having problem logging to the server, please try again in a moment.."
                        }
                            
                    }
                });

                
                
            },
     
         
        },
        created(){
        
        },
        mounted(){
            self = this
            
           
            self.initEvents()      
            self.initCalendar()
            
           
        },
        
        beforeDestroy() {
            $('#calendar').fullCalendar('destroy')
            
        },
        computed:{
            errorMsg: function(){
            return this.error
            },
            alertMsg: function(){
                return this.alert
            },
            eventsComp: function(){
                return this.events
                
            }
         
        }
}
</script>

<style scoped>
    .disabled{
        background-color: silver;
    }

    .unavailable {
            background-color: red;
    }

    
 
.fc-time, .fc-title{
     display : none;
}



.wrapper{
  border:1px;
  border-style:solid;
  border-radius:5px;
  border-color:#c8c7c7;
  
  padding:10px;
  padding-top: 0px;
  
}



</style>



// WEBPACK FOOTER //
// CalendarView.vue?2753a2c1